export function getZonificationCloudyMessage(): string {
  return 'La imagen seleccionada es muy nubosa.<br>¿Desea aplicar la Zonificación?';
}

export function getNdviDiffCloudyMessage(initialCloudy: boolean, finalCloudy: boolean): string {
  if (initialCloudy && finalCloudy) {
    return 'Las fechas inicial y final tienen mucha nubosidad.<br>¿Desea aplicar el Diferencial NDVI?';
  }
  if (initialCloudy) {
    return 'La fecha inicial tiene mucha nubosidad.<br>¿Desea aplicar el Diferencial NDVI?';
  }
  return 'La fecha final tiene mucha nubosidad.<br>¿Desea aplicar el Diferencial NDVI?';
}
